// extracted by mini-css-extract-plugin
export default {"ctaButton":"VtcLBu","variantSecondary":"hLkqvl"};